<!-- *ngIf prevents user from focusing any tabbable elements if slideout isn't visible -->
<ng-container *ngIf="!_hasFinishedHiding">
    <ng-content></ng-content>
</ng-container>
